const BASE_COLOR = "#852C64";
export const RedirectUrlComponent = ['$scope', 'MainService', 'ConfigurableRedirectService', 'configurableUrl', '$mdDialog', 'ColorService',
    redirectUrlComponent];

export function redirectUrlComponent($scope, MainService, ConfigurableRedirectService, configurableUrl, $mdDialog, ColorService) {
    $scope.configurableUrl = Object.assign({}, configurableUrl);
    $scope.configurableUrl.parameters = configurableUrl.parameters ? configurableUrl.parameters : [];
    $scope.redirectUrl = configurableUrl.redirectUrl;

    let path_parameter_value_regex = /(\{\{[^\}]*\}\})/g;

    MainService.assignPrinciple((resp) => {
        $scope.redirect_subdomain = resp.currentBrand.brandRedirectHostName;
    });


    $scope.newUrlParameterName = "";
    $scope.newUrlParameterValue = "";
    $scope.updateMatchUrl = updateMatchUrl;
    updateMatchUrl();
    updateRedirectUrl();

    this.$onInit = function () {
    };

    $scope.saveRedirect = function () {
        ConfigurableRedirectService.saveRedirect($scope.configurableUrl)
            .then((resp) => {
                $mdDialog.hide(resp.data);
            })
    };

    $scope.addUrlParameter = function () {
        $scope.configurableUrl.parameters.push({
            parameterName: $scope.newUrlParameterName,
            parameterValue: $scope.newUrlParameterValue,
            parameterColor: ColorService.changeHue(BASE_COLOR, Math.ceil(Math.random() * 360)),
            isPathParameter: true
        });
        $scope.newUrlParameterValue = "";
        $scope.newUrlParameterValue = "";
        updateMatchUrl();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.deleteRedirectUrlParameter = function (parameter) {
        let parameters = $scope.configurableUrl.parameters;
        parameters.splice(parameters.indexOf(parameter), 1);
    };

    $scope.updateRedirectUrl = updateRedirectUrl;


    function updateMatchUrl() {
        let matchUrl = $scope.redirect_subdomain + $scope.configurableUrl.matchUrlPath;
        let parsedURL = new URL(matchUrl);
        let qParameters = getQueryParameters(parsedURL.search);
        let parsedSearch = parseUrlParameters(qParameters);
        $scope.matchUrlPath = parsedURL.pathname + parsedSearch;
    }

    function updateRedirectUrl() {
        try {
            let redirectUrl = highlightParameters($scope.redirectUrl, $scope.configurableUrl.parameters);
            $scope.finalRedirectValue = redirectUrl;
            $scope.configurableUrl.redirectUrl = $scope.redirectUrl;
        } catch (e) {
            //ignore mailformated url, for now
            //todo add validation error here
        }
    }

    function validateRedirect(redirect) {
        let valid = true;
        let redirectParameters = redirect.parameters;
        let redirectUrl = redirect.redirectUrl;
        for (let p of redirectParameters) {
            if (!redirectUrlContainsParams(redirectUrl, p)) {
                return false;
            }
        }
        if (!redirectUrlValid(redirectUrl)) {
            return false;
        }

    }


    function redirectUrlValid(redirectUrl) {
        try {
            let formatedUrl = new URL(redirectUrl);
            return true;
        } catch (e) {
            return true;
        }
    }

    function redirectUrlContainsParams(redirectUrl, parameter) {
        if (!redirectUrl.contains(convertIntoPathVarName(parameter))) {
            return false;
        }
    }

    function convertIntoPathVarName(name) {
        return "{{" + name + "}}";
    }


    function highlightParameters(url, parameters) {
        for (let p of parameters) {
            let search = convertIntoPathVarName(p.parameterValue);
            url = url.replaceAll(search, createSpan(search, p).outerHTML);
        }
        return url;
    }

    function createSpan(text, param) {
        let res = document.createElement('span');
        res.innerText = text;
        if (param.parameterColor) res.style.color = param.parameterColor;
        return res;
    }


    function findAllOcurrances(txt) {
        let matches = [];
        let match = path_parameter_value_regex.exec(txt);
        while (match) {
            let matched_str = match[1];
            matches.push(matched_str);
            matches.push(match[1]);
            match = path_parameter_value_regex.exec(txt);
        }
        return matches;
    }

    function parseUrlParameters(urlParametes) {
        let combinedParameters = urlParametes.concat($scope.configurableUrl.parameters);
        if (combinedParameters.length > 0) {
            let finalSearch = "?";
            finalSearch = addParametersToTheString(finalSearch, combinedParameters);
            finalSearch = finalSearch.substring(0, finalSearch.length - 1);
            return finalSearch;
        } else {
            return "";
        }
    }

    function addParametersToTheString(string, parameters) {
        for (let p of parameters) {
            let value = createSpan(convertIntoPathVarName(p.parameterValue), p);
            string += p.parameterName + "=" + value.outerHTML + "&";
        }
        return string;
    }

    function getQueryParameters(search) {
        let urlParameters = [];
        let urlQueryParams = new URLSearchParams(search);
        for (let qpKey of urlQueryParams.keys()) {
            urlParameters.push({
                parameterName: qpKey,
                parameterValue: urlQueryParams.get(qpKey),
            });
        }
        return urlParameters;
    }

    function findParameterMatches(string) {
        return string.match(string);
    }
}

